<template>
  <div class="fshr-resortFacilities">
    <ul class="fshr-resortFacilities__list">
      <li
        class="fshr-resortFacilities__item"
        v-for="facility in facilities"
        :key="facility.order"
      >
        <img
          :src="facility.img"
          class="fshr-resortFacilities__img"
          :alt="facility.name"
          v-tooltip="{
            content: `${facility.name}`,
            html: false,
            classes: 'fshr-basicTooltip',
            offset: 15,
          }"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "resort-facilities",
  props: {
    facilities: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="less">
  @import './../../less/variables';
  @import "./../../../../../../Content/css/common/component-resort-facilities.less";
</style>
